import React from 'react'
import { Tooltip } from 'react-tooltip'

// Tranlations
import { supportedLanguages } from '../../../translations'
import t from '../../../translations'

const LanguageToggle = (props) => {
    const handleLanguage = () => {
        let currentLangIndex = supportedLanguages.indexOf(props.lang ?? 'FR')
        const nextLang = supportedLanguages[(currentLangIndex + 1) % supportedLanguages.length]
        props.setLang(nextLang)
        localStorage.setItem('language', nextLang)
    }

    return <div className='languageTrigger'>
        <span>{t.LANG[props.lang]}</span>
        <Tooltip id='toggle-language' className='tooltip'></Tooltip>
        <div
            data-tooltip-id='toggle-language'
            data-tooltip-content={t[props.lang]['Set Language']}
            data-tooltip-place='left'>
                <box-icon
                type='regular'
                name='globe'
                color='white'
                onClick={() => handleLanguage()}
            />
        </div>
    </div>
}

export default LanguageToggle